import { render, staticRenderFns } from "./BasicForm.vue?vue&type=template&id=15243909"
import script from "./BasicForm.vue?vue&type=script&lang=js"
export * from "./BasicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15243909')) {
      api.createRecord('15243909', component.options)
    } else {
      api.reload('15243909', component.options)
    }
    module.hot.accept("./BasicForm.vue?vue&type=template&id=15243909", function () {
      api.rerender('15243909', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/form/BasicForm.vue"
export default component.exports